<template>
  <CardBase :headerBorder="false">
    <template #header>{{ $route.meta.title }}</template>
    <template #toolbar>
      <router-link
        v-if="userCan('create.bank-account')"
        :to="{ name: 'BankAccountCreate' }"
        class="button button--primary poppins"
      >
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-1" />New
        Bank
      </router-link>
    </template>
    <template #content>
      <form class="form form-search" method="get" @submit.prevent="reloadTable">
        <div class="form-search__row">
          <div class="form-search__double">
            <label class="form__label">Search</label>
            <input
              type="text"
              class="form__input"
              placeholder="Account Holder / Number"
              v-model="formData.search"
            />
          </div>
          <div class="form-search__double">
            <label class="form__label">Group</label>
            <select
              class="form__input"
              v-model="formData.bank_group_id"
              @change="filterListBank"
            >
              <option value="">Show All</option>
              <option
                v-for="row in listBankGroup"
                :key="row.id"
                :value="row.id"
              >
                {{ row.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-search__row">
          <div class="form-search__double">
            <label class="form__label">Bank</label>
            <select class="form__input" v-model="formData.bank_id">
              <option value="">Show All</option>
              <option v-for="row in listBank" :key="row.id" :value="row.id">
                {{ row.name }}
              </option>
            </select>
          </div>
          <div class="form-search__double">
            <label class="form__label">Type</label>
            <select class="form__input" v-model="formData.bank_type_id">
              <option value="">Show All</option>
              <option v-for="row in listBankType" :key="row.id" :value="row.id">
                {{ row.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-search__row">
          <div class="form-search__double">
            <label class="form__label">Category</label>
            <select class="form__input" v-model="formData.bank_category_id">
              <option value="">Show All</option>
              <option
                v-for="row in listBankCategory"
                :key="row.id"
                :value="row.id"
              >
                {{ row.name }}
              </option>
            </select>
          </div>
          <div class="form-search__double">
            <label class="form__label">Service</label>
            <select class="form__input" v-model="formData.bank_service_id">
              <option value="">Show All</option>
              <option
                v-for="row in listBankService"
                :key="row.id"
                :value="row.id"
              >
                {{ row.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="form-search__row">
          <!-- <div class="form-search__double">
            <label class="form__label">Asset</label>
            <select class="form__input" v-model="formData.asset_id">
              <option value="">Show All</option>
              <option v-for="row in listAsset" :key="row.id" :value="row.id">
                {{ row.name }}
              </option>
            </select>
          </div> -->
          <div class="form-search__double">
            <label class="form__label">Asset Group</label>
            <select class="form__input" v-model="formData.group_id">
              <option value="" v-if="listGroup.length > 1">Show All</option>
              <option value="" v-if="listGroupLoading">Please wait</option>
              <option v-for="row in listGroup" :key="row.id" :value="row.id">
                {{ row.code_name }}
              </option>
            </select>
          </div>
          <div class="form-search__double">
            <label class="form__label">Status</label>
            <select class="form__input" v-model="formData.status">
              <option value="">Show All</option>
              <option value="1">Active</option>
              <option value="2">Blocked</option>
            </select>
          </div>
        </div>

        <div class="form-search__action">
          <div class="w-full flex">
            <BaseButton type="submit" buttonClass="secondary"
              >Search</BaseButton
            >
            <BaseButton
              class="mx-2"
              type="button"
              buttonClass="default"
              @click="reset"
              >Reset Search</BaseButton
            >
          </div>
        </div>
      </form>

      <div class="form-search__single">
        <FormNote class="mb-6"
          >Note: Untuk saldo diatas <strong>laundry limit</strong> setiap bank
          akan ditandakan dengan warna kuning.</FormNote
        >
      </div>

      <vue-good-table
        :key="tableKey"
        mode="remote"
        theme="polar-bear"
        :rows="tableData.rows"
        :columns="tableData.columns"
        :total-rows="tableData.totalRows"
        :isLoading="tableData.isLoading"
        :sort-options="{
          enabled: false,
        }"
        :pagination-options="{
          enabled: true,
          perPageDropdown: perPageDropdown,
          dropdownAllowAll: false,
          setCurrentPage: tableData.currentPage,
          infoFn: tablePageInfo,
        }"
        styleClass="vgt-table striped bordered"
        :row-style-class="rowStyleClass"
        @on-page-change="onPageChange"
        @on-per-page-change="onPerPageChange"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'balance'">
            <router-link
              v-if="userCan('read.bank-transaction')"
              class="text-blue-500 underline"
              :to="{
                name: 'BankTransactionList',
                params: { bankId: props.row.uuid },
              }"
              v-tooltip="`List Transaction ${props.row.name}`"
              >{{ props.row.balance }}</router-link
            >
            <span v-else>{{ props.row.balance }}</span>
          </span>
          <span v-else-if="props.column.field == 'bank_type_id'">
            {{ props.row.bank_type.name }}
          </span>
          <span v-else-if="props.column.field == 'bank_category_id'">
            {{ props.row.bank_category.name }}
          </span>
          <span v-else-if="props.column.field == 'bank_service_id'">
            {{ props.row.bank_service.name }}
          </span>
          <span v-else-if="props.column.field == 'status'">
            <span class="flex items-center" v-if="props.row.status == 0">
              <font-awesome-icon
                :icon="['fas', 'times-circle']"
                class="text-yellow-500 mr-2"
                size="lg"
              />Inactive
            </span>

            <span class="flex items-center" v-if="props.row.status == 1">
              <font-awesome-icon
                :icon="['fas', 'check-circle']"
                class="text-green-500 mr-2"
                size="lg"
              />Active
            </span>

            <span class="flex items-center" v-else-if="props.row.status == 2">
              <font-awesome-icon
                :icon="['fas', 'exclamation-triangle']"
                class="text-red-500 mr-2"
                size="lg"
              />Blocked
            </span>
          </span>
          <span v-else-if="props.column.field == 'uuid'">
            <router-link
              v-if="userCan('create.bank-transaction')"
              :to="{
                name: 'BankTransactionCreate',
                params: { bankId: props.row.uuid },
              }"
              v-tooltip="`Add Transaction ${props.row.name}`"
              class="table-action__link"
            >
              <font-awesome-icon :icon="['fas', 'coins']" />
            </router-link>
            <router-link
              v-if="userCan('update.bank-account')"
              :to="{ name: 'BankAccountEdit', params: { id: props.row.uuid } }"
              v-tooltip="`Edit ${props.row.name}`"
              class="table-action__link mx-2"
            >
              <font-awesome-icon :icon="['fas', 'edit']" />
            </router-link>
            <button
              v-if="userCan('delete.bank-account')"
              class="table-action__link"
              v-tooltip="'Delete ' + props.row.name"
              @click="deleteBankAccount(props.row.uuid, props.row.name)"
            >
              <font-awesome-icon :icon="['far', 'trash-alt']" />
            </button>
          </span>
        </template>
      </vue-good-table>
    </template>
  </CardBase>
</template>

<script>
import { parse } from "vue-currency-input";
import { showListMixin } from "@/mixins/showListMixin";
import { getListBankOptionsMixin } from "@/mixins/getListBankOptionsMixin";

export default {
  mixins: [showListMixin, getListBankOptionsMixin],
  data: () => {
    return {
      listGroup: [],
      listGroupLoading: true,
      formData: {
        search: "",
        bank_group_id: "",
        bank_id: "",
        bank_type_id: "",
        bank_category_id: "",
        bank_service_id: "",
        // asset_id: "",
        group_id: "",
        status: "",
      },
      tableData: {
        columns: [
          {
            label: "Groups",
            field: "groups",
            hidden: true,
          },
          {
            label: "Assets",
            field: "assets",
          },
          {
            label: "Name",
            field: "name",
          },
          {
            label: "Balance",
            field: "balance",
          },
          {
            label: "Type",
            field: "bank_type_id",
          },
          {
            label: "Category",
            field: "bank_category_id",
          },
          {
            label: "Service",
            field: "bank_service_id",
          },
          {
            label: "Status",
            field: "status",
          },
          {
            label: "",
            field: "uuid",
            thClass: "vgt-table__action",
            tdClass: "vgt-table__action",
          },
        ],
        sort_by: "holder",
        sort_dir: "asc",
      },
    };
  },
  created() {
    this.getListGroup();
    this.getListBank();
    this.getListBankGroup();
    this.getListBankType();
    this.getListBankCategory();
    this.getListBankService();

    const allowedRole = [
      "FINANCE",
      "LAUNDRY",
      "ROOT",
      "SUPER ADMINISTRATOR",
      "SUPERVISOR",
      "AUDIT",
    ];

    if (allowedRole.includes(this.getRole)) {
      this.tableData.columns[0].hidden = false;
    }
  },
  computed: {
    getRole() {
      return this.$store.getters.getRole;
    },
  },
  methods: {
    deleteBankAccount(id, name) {
      this.$swal({
        title: "Delete " + name,
        text: "Are you sure?",
        icon: "warning",
        showCancelButton: true,
        reverseButtons: true,
      }).then((res) => {
        if (res.value) {
          this.$store.commit("toggleLoading");
          this.$http
            .delete(process.env.VUE_APP_API_URL + this.$route.path + "/" + id)
            .then((res) => {
              this.$store.commit("toggleLoading");
              if (res.status == 200) {
                this.$swal({
                  title: "All done!",
                  text: res.data.message,
                  icon: "success",
                }).then(() => {
                  this.loadTableData();
                });
              }
            })
            .catch((res) => {
              if (res.response.status == 409) {
                this.$store.commit("toggleLoading");
                this.$swal({
                  title: "Whoops!",
                  text: res.response.data.data.bank_account,
                  icon: "error",
                });
              }
            })
            .finally(() => {});
        }
      });
    },
    getListGroup() {
      this.listGroupLoading = true;
      this.$http
        .get(process.env.VUE_APP_API_URL + "/group?central=1&bank_account=1")
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listGroup = response.data;
              if (this.listGroup.length == 1) {
                this.formData.group_id = this.listGroup[0].id;
              }
            }
          }
        })
        .finally(() => {
          this.listGroupLoading = false;
        });
    },
    filterListBank() {
      this.formData.bank_id = "";
      this.getListBank(this.formData.bank_group_id);
    },
    reset() {
      this.formData.search = "";
      this.formData.bank_group_id = "";
      this.formData.bank_id = "";
      this.formData.bank_type_id = "";
      this.formData.bank_category_id = "";
      this.formData.bank_service_id = "";
      // this.formData.asset_id = "";
      (this.formData.group_id = ""), (this.formData.status = "");
      this.tableData.limit = 10;

      if (this.$route.query.search == undefined) {
        this.tableKey++;
      } else {
        this.tableData.currentPage = 1;
        this.$router.push({ name: "BankAccountList" }).catch(() => {});
      }
    },
    reloadTable() {
      if (this.formData.search && this.formData.search.length < 3) {
        this.$swal({
          position: "bottom-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          title: "Search query must have at least 3 characters",
          icon: "warning",
        });
      } else {
        this.tableData.currentPage = 1;
        this.$router
          .replace({
            query: {
              search: this.formData.search,
              bank_group_id: this.formData.bank_group_id,
              bank_id: this.formData.bank_id,
              bank_type_id: this.formData.bank_type_id,
              bank_category_id: this.formData.bank_category_id,
              bank_service_id: this.formData.bank_service_id,
              // asset_id: this.formData.asset_id,
              group_id: this.formData.group_id,
              status: this.formData.status,
              tz: new Date().getTime(),
            },
          })
          .catch(() => {});
      }
    },
    rowStyleClass(row) {
      if (row.status == 2) {
        return "bank-blocked";
      } else {
        return parse(row.balance) >= parse(row.limit_laundry)
          ? "laundry-alert"
          : "";
      }
    },
  },
};
</script>
